import { PropsWithChildren } from 'react'
import css from './progress.module.css'

export interface IAnalyticsCircleProps {
  value: number
  size: 'large' | 'default' | 'small'
  type: 'success' | 'primary' | 'danger' | 'warning'
}

const AnalyticsProgressCircle = ({ value, size, type, children }: PropsWithChildren<IAnalyticsCircleProps>) => {
  // Толщина обводки для каждого размера
  const strokeWidth = size === 'large' ? 6 : size === 'default' ? 4 : 3

  // Радиус круга с учетом толщины обводки
  const diameter = size === 'large' ? 120 : size === 'default' ? 80 : 24
  const radius = (diameter - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (value / 100) * circumference

  return (
    <div className={css.wrapper} data-type={type} data-size={size}>
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${diameter} ${diameter}`} // Учитываем толщину обводки
      >
        {/* Фон круга */}
        <circle className={css.circleBackground} cx={diameter / 2} cy={diameter / 2} r={radius} fill="none" />
        {/* Прогресс-бар */}
        <circle
          className={css.circleProgress}
          cx={diameter / 2}
          cy={diameter / 2}
          r={radius}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      {size !== 'small' && (
        <div className={css.children} data-type={type}>
          {children ? (
            children
          ) : (
            <span className={css.percentageText} data-size={size}>
              {value.toFixed(1)}%
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default AnalyticsProgressCircle
